import React, { useEffect, useState } from 'react';
import { Select, MenuItem } from '@mui/material';
import ValueInput from '../components/ValueInput';
import { ThemeProvider } from '@mui/material/styles';
import { createTheme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';
import ColorConstants from '../../../defaults/ColorConstants';

const theme = createTheme({
  overrides: {
  },
});

const useStyles = makeStyles({
  root: {
    "&:hover": {
      borderLeft: `4px solid ${ColorConstants.BlueAlien} !important`,
    }
  },
});

const style = {
  valueInput: {
    // overrides here?
  },
  selectInput: {
    // overrides here?
  }
};

export default function RelativeDateChooser({ selectedValue, onChange }) {
  const classes = useStyles();
  const [value, setValue] = useState({timeSizeValue: 1, timeSpanValue: "days"});
  useEffect(() => {
    const timeSizeValue =
    selectedValue.timeSizeValue || value.timeSizeValue;
    const timeSpanValue =
    selectedValue.timeSpanValue || value.timeSpanValue;

    if(Number(timeSizeValue) !== Number(value.timeSizeValue) || timeSpanValue !== value.timeSpanValue){
      setValue({timeSizeValue: Number(timeSizeValue), timeSpanValue: timeSpanValue});
      onChange({timeSizeValue: Number(timeSizeValue), timeSpanValue: timeSpanValue});
    }
  }, [value, onChange, selectedValue])

  
  const handleNumberValueChange = e => {
    setValue({...value, timeSizeValue: Number(e.code)})
    onChange({...value, timeSizeValue: Number(e.code)});
  };

  
  const handleSelectOptionChange = e => {
    setValue({...value, timeSpanValue: e});
    let val = "";
    if(e && e.target){
      val = e.target.value;
    }
    setValue({...value, timeSpanValue: val});
    onChange({...value, timeSpanValue: val});
  };

    return (
      <ThemeProvider theme={theme}>
      <div style={{ display: 'inline-flex' }}>
        <ValueInput
          style={style.valueInput}
          value={value?.timeSizeValue ? value.timeSizeValue : ''}
          type="number"
          onChange={handleNumberValueChange}
        />
        <Select
          style={style.selectInput}
          value={value?.timeSpanValue ? value.timeSpanValue : ''}
          onChange={handleSelectOptionChange}
          MenuProps={{
            sx: {
              "&& .Mui-selected": {
                borderLeft: `4px solid ${ColorConstants.BlueAlien} !important`
              },
            }
          }}
        >
          <MenuItem value="minutes" classes={{root: classes.root, selected: classes.selected}} style={{ display: 'block', padding: 5, borderLeft: `4px solid ${ColorConstants.WhiteAlien}`}}>minute(s)</MenuItem>
          <MenuItem value="hours" classes={{root: classes.root, selected: classes.selected}} style={{ display: 'block', padding: 5, borderLeft: `4px solid ${ColorConstants.WhiteAlien}`}}>hour(s)</MenuItem>
          <MenuItem value="days" classes={{root: classes.root, selected: classes.selected}} style={{ display: 'block', padding: 5, borderLeft: `4px solid ${ColorConstants.WhiteAlien}`}}>day(s)</MenuItem>
          <MenuItem value="weeks" classes={{root: classes.root, selected: classes.selected}} style={{ display: 'block', padding: 5, borderLeft: `4px solid ${ColorConstants.WhiteAlien}`}}>week(s)</MenuItem>
          <MenuItem value="months" classes={{root: classes.root, selected: classes.selected}} style={{ display: 'block', padding: 5, borderLeft: `4px solid ${ColorConstants.WhiteAlien}`}}>month(s)</MenuItem>
          <MenuItem value="years" classes={{root: classes.root, selected: classes.selected}} style={{ display: 'block', padding: 5, borderLeft: `4px solid ${ColorConstants.WhiteAlien}`}}>year(s)</MenuItem>
        </Select>
      </div>
      </ThemeProvider>
    );
}